var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C90E2690-EE4D-468A-9C1D-4A0F61E9FE5E") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Questionnaire",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Q-P20-Y-S2",
    transform: "translate(-865.000000, -694.000000)",
    fill: "#929AA6",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Policyholder",
    transform: "translate(308.000000, 686.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M566,8 C561.037464,8 557,12.037464 557,17 C557,21.962536 561.037464,26 566,26 C570.962536,26 575,21.962536 575,17 C575,12.037464 570.962502,8 566,8 Z M566.585423,22.3399194 C566.157841,22.4112003 565.307037,22.5892308 564.874991,22.6250086 C564.509282,22.6552927 564.164174,22.445948 563.953799,22.1454421 C563.742875,21.8449706 563.692333,21.4604453 563.817555,21.1154747 L565.518785,16.4375129 L563.749983,16.4375129 C563.748472,15.4627572 564.479616,14.7460342 565.414748,14.4709711 C565.861009,14.3396714 566.692448,14.1599928 567.124974,14.18753 C567.384106,14.2040112 567.835792,14.3665906 568.046166,14.6670965 C568.25709,14.967568 568.307632,15.3520933 568.18241,15.6970639 L566.48118,20.3750258 L568.249433,20.3750258 C568.249777,21.3486483 567.545895,22.1798465 566.585423,22.3399194 L566.585423,22.3399194 Z M567.124974,13.6250086 C566.503636,13.6250086 565.999966,13.1212698 565.999966,12.5 C565.999966,11.8786615 566.503636,11.3749914 567.124974,11.3749914 C567.746313,11.3749914 568.249983,11.8786615 568.249983,12.5 C568.249983,13.1213041 567.746347,13.6250086 567.124974,13.6250086 Z",
    id: "icon-information"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInformation);
export default __webpack_public_path__ + "static/media/icon-information.9d1184e84a15676f1a1bfbfee18b1557.svg";
export { ForwardRef as ReactComponent };